'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _BaseButton = require('../../components/BaseButton/BaseButton');

var _DefaultString = require('../../helpers/DefaultString');

var _PopupType = require('../../helpers/PopupType');

var _Product = require('../../helpers/Product');

var _PostLoginFlowStrategySelector = require('../../login/strategy/PostLoginFlowStrategySelector');

var _PostLoginFlowStrategySelector2 = _interopRequireDefault(_PostLoginFlowStrategySelector);

var _auth = require('../../redux/modules/auth');

var _popup = require('../../redux/modules/popup');

var _ApproveAgreements = require('./ApproveAgreements.scss');

var _ApproveAgreements2 = _interopRequireDefault(_ApproveAgreements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApproveAgreements = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo, auth: state.auth, log: state.log };
}, { approveAgreements: _auth.approveAgreements, changePopupType: _popup.changePopupType, linkIdentityToAccount: _auth.linkIdentityToAccount, linkSecureToken: _auth.linkSecureToken, linkSSOToken: _auth.linkSSOToken, pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ApproveAgreements, _Component);

  function ApproveAgreements() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ApproveAgreements);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ApproveAgreements.__proto__ || (0, _getPrototypeOf2.default)(ApproveAgreements)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: false
    }, _this.approveAgreements = function () {
      _this.setState({ loading: true });
      _this.props.approveAgreements();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ApproveAgreements, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.gettingApproveAgreements && !nextProps.auth.gettingApproveAgreements) {
        // Approve Agreements
        if (nextProps.auth.error) {
          this.setState({ loading: false });
          this.props.changePopupType(_PopupType.PopupId.UnknownError);
        } else {
          var loginStrategy = _PostLoginFlowStrategySelector2.default.getPostLoginFlowStrategy(nextProps.auth, this.props.appInfo, this.props.pushState, this.props.log);
          loginStrategy.handleUserInfoResponse(this.props.linkIdentityToAccount, this.props.linkSecureToken, this.props.linkSSOToken);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var formatMessage = this.props.intl.formatMessage;
      // TODO fr, an aall

      var termsLink = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, _DefaultString.translations.TermsConditionsLink, {
        values: {
          link: (0, _Product.getTermsString)(formatMessage, this.props.auth.productName, this.props.appInfo.excludeHeader)
        }
      }));
      var privacyLink = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, _DefaultString.translations.PrivacyPolicyLink, {
        values: {
          link: (0, _Product.getPrivacyString)(formatMessage, this.props.auth.productName, this.props.appInfo.excludeHeader)
        }
      }));

      var confirmTheme = this.props.auth.productName !== _Product.PRODUCT_NAMES.Music ? _BaseButton.ButtonTheme.CallToAction : '';
      return _react2.default.createElement(
        'div',
        { className: _ApproveAgreements2.default.approveAgreements },
        _react2.default.createElement(
          'div',
          { className: _ApproveAgreements2.default.approveAgreementsContent },
          _react2.default.createElement(
            'div',
            { className: _ApproveAgreements2.default.title },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.ApproveAgreementsTitle)
          ),
          _react2.default.createElement(
            'div',
            { className: _ApproveAgreements2.default.message },
            _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _DefaultString.translations.ApproveAgreementsMessage, {
              values: { termsLink: termsLink, privacyLink: privacyLink }
            }))
          ),
          _react2.default.createElement(_components.BaseButton, {
            className: _ApproveAgreements2.default.submit,
            onClick: function onClick() {
              return _this2.approveAgreements();
            },
            buttonString: _DefaultString.translations.ApproveAgreementsAccept,
            loading: this.state.loading,
            theme: confirmTheme
          })
        )
      );
    }
  }]);
  return ApproveAgreements;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  approveAgreements: _react.PropTypes.func.isRequired,
  auth: _react.PropTypes.object,
  changePopupType: _react.PropTypes.func,
  intl: _reactIntl.intlShape.isRequired,
  linkIdentityToAccount: _react.PropTypes.func,
  linkSecureToken: _react.PropTypes.func,
  linkSSOToken: _react.PropTypes.func,
  log: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(ApproveAgreements);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ApproveAgreements/ApproveAgreements.js
// module id = 1993
// module chunks = 0